import { render } from "./bannerComponent.vue?vue&type=template&id=b2a2fe4e&scoped=true"
import script from "./bannerComponent.vue?vue&type=script&lang=js"
export * from "./bannerComponent.vue?vue&type=script&lang=js"

import "./bannerComponent.vue?vue&type=style&index=0&id=b2a2fe4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a2fe4e"]])

export default __exports__